import React from "react";
import { FaRobot, FaChartLine, FaGlobeAmericas } from "react-icons/fa";

export default function AboutEthraAI() {
  return (
   <section className="w-full bg-black py-6 px-2" id="about">
  <div className="mx-auto max-w-[1800px] rounded-xl border border-[#c4dc5b]/30 bg-[#050505] overflow-hidden">
    <div className="grid grid-cols-1 lg:grid-cols-2">
      
      {/* LEFT SIDE */}
      <div className="relative flex items-center justify-center p-6">
        <img
          src="/img123.png"
          alt="About ETHRA AI"
          className="w-full max-w-[800px] object-contain"
        />

        {/* Vertical glowing divider */}
        <span className="absolute right-0 top-1/2 hidden h-[85%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent lg:block" />
      </div>

      {/* RIGHT SIDE */}
      <div className="flex flex-col justify-center p-8">
        <h2 className="text-4xl font-bold">
          <span className="text-[#c4dc5b]">ABOUT</span>{" "}
          <span className="text-white">ETHRA AI</span>
        </h2>

        <p className="mt-5 text-lg leading-8 text-gray-300">
          Ethra AI combines artificial intelligence with blockchain technology
          to revolutionize the way trading works in DeFi. Our mission is to
          create a transparent, profitable, and sustainable ecosystem that
          empowers every holder and sets a new standard in the crypto space.
        </p>

        {/* Feature Box */}
   <div className="grid grid-cols-1 md:grid-cols-3 border border-[#c4dc5b]/30 rounded-xl overflow-hidden">

  {/* Box 1 */}
  <div className="relative flex items-center gap-4 p-5">
    <img src="/icon5.png" className="w-20 h-20" alt="" />

    <div>
      <p className="text-[#c4dc5b] font-bold text-lg">AI POWERED</p>
      <p className="text-white">TRADING BOT</p>
    </div>

    {/* Divider */}
    <span className="absolute right-0 top-1/2 hidden h-[70%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
  </div>

  {/* Box 2 */}
  <div className="relative flex items-center gap-4 p-5">
    <img src="/icon3.png" className="w-20 h-20" alt="" />

    <div>
      <p className="text-[#c4dc5b] font-bold text-lg">100%</p>
      <p className="text-white">TRANSPARENT</p>
    </div>

    {/* Divider */}
    <span className="absolute right-0 top-1/2 hidden h-[70%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
  </div>

  {/* Box 3 */}
  <div className="flex items-center gap-4 p-5">
    <img src="/icon2.png" className="w-20 h-20" alt="" />

    <div>
      <p className="text-[#c4dc5b] font-bold text-lg">COMMUNITY</p>
      <p className="text-white">FOCUSED</p>
    </div>
  </div>

</div>
      </div>

    </div>
  </div>
</section>
  );
}

function Feature({ icon, title, text }) {
  return (
    <div className="flex items-center gap-4 border-b border-[#c4dc5b]/20 px-5 py-4 last:border-b-0 sm:border-b-0 sm:border-r sm:last:border-r-0">
      <div className="text-3xl text-[#c4dc5b]">{icon}</div>
      <div>
        <div className="font-bold text-[#c4dc5b]">{title}</div>
        <div className="text-sm font-semibold text-white">{text}</div>
      </div>
    </div>
  );
}